import { fisApiAction } from "../actions/types";
const empState = {};

export default function reducer(state = empState, action) {
  switch (action.type) {
    case fisApiAction.EMPDETAILS:
      const {
        BadgeNumber,
        EmployeeFirstName,
        EmployeeLastName,
        Position,
        EmployeeEmailAddress,
        CostCenter,
        Department,
      } = action.payload;
      const employeeDetails = {
        BADGENUMBER: BadgeNumber,
        FIRSTNAME: EmployeeFirstName,
        LASTNAME: EmployeeLastName,
        JOB_TITLE: Position,
        EMAIL: EmployeeEmailAddress,
        COST_CENTER: CostCenter,
        DEPARTMENT: Department,
      };

      if (employeeDetails.FIRSTNAME === "null") {
        return { ...state, empdetails: {} };
      } else {
        return { ...state, empdetails: employeeDetails };
      }
    case fisApiAction.EMPNOTFOUND:
      return { ...state, errorMessage: action.payload };
    default:
      return state;
  }
}
